const SELECTION_IDS = {
  FIRST: 1,
  SECOND: 2,
};

const CHECKBOX_IDS = {
  FIRST: "first",
  SECOND: "second",
};

export const RECAP_FEEDBACK_ACTION = {
  ADD: 1,
  DELETE: 2,
  CHANGE: 3,
  SONG_FEEDBACK: 4,
  SIMPLE_FEEDBACK: 5,
};

export const recapConstants = {
  SELECTION_IDS,
  CHECKBOX_IDS,
  OPTIONS: [
    { label: "add clip", value: RECAP_FEEDBACK_ACTION.ADD },
    { label: "delete clip", value: RECAP_FEEDBACK_ACTION.DELETE },
    { label: "change clip", value: RECAP_FEEDBACK_ACTION.CHANGE },
    { label: "song feedback", value: RECAP_FEEDBACK_ACTION.SONG_FEEDBACK },
  ],
};
